import { Directive, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { CheckboxComponent } from '@shared/checkbox/checkbox.component';
import { ProjectSection } from '../models/access.models';
import { AccessService } from '../services/access.service';

/**
 * Directive: PermCheckboxDirective
 *
 * Автоматически блокирует (устанавливает `isLock=true`) компонент `<app-checkbox>`
 * если текущий пользователь не имеет права `<section>:edit`.
 * Работает аналогично уже существующим директивам `PermSelectDirective`
 * и `PermFormDirective`. Секция берётся из `data['section']` маршрута.
 * Директива подключается через `AccessUiModule` и применяется к каждому
 * `<app-checkbox>` в шаблонах без дополнительного кода.
 */

@Directive({ selector: 'app-checkbox' })
export class PermCheckboxDirective implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();
  private _weLocked = false;

  constructor(
    @Optional() @Self() private readonly _checkbox: CheckboxComponent,
    private readonly _route: ActivatedRoute,
    private readonly _access: AccessService,
  ) {}

  ngOnInit(): void {
    const data = this._route.snapshot.data ?? {};
    const section = data['section'] as ProjectSection | undefined;

    if (!section || data['skipPermDisable'] || !this._checkbox) {
      return;
    }

    this._access
      .can$(section, 'edit')
      .pipe(takeUntil(this._destroy$))
      .subscribe((canEdit) => {
        if (!canEdit) {
          this._checkbox.isLock = true;
          this._weLocked = true;
        } else if (this._weLocked) {
          this._checkbox.isLock = false;
          this._weLocked = false;
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
